import {
  Breakfast2,
  Fruits2,
  KidsSnacks2,
  Snacks2,
  Sweets3,
} from '@hungryroot/icons';
import { type PlanServicePlanComponents } from '@hungryroot/rest';
import { getPricingVersionFromPlanComponents } from '../utils/getPricingVersionFromPlanComponents';

type Icon = {
  name: string;
  imageUrl: string | null;
  className: string;
};

type SubHeader = {
  name: string;
  subHeader: string | null;
};

export function usePlanNameHeaderIcon(
  planComponents?: PlanServicePlanComponents
) {
  if (planComponents === undefined) {
    return undefined;
  }

  const pricingVersion = getPricingVersionFromPlanComponents(planComponents);

  if (pricingVersion >= 15) {
    return {
      getName: (name: string) => {
        switch (name) {
          case 'Throughout The Day':
            return 'Other Groceries';
          default:
            return name;
        }
      },
      getSubHeader: ({ name, subHeader }: SubHeader) => {
        switch (name) {
          case 'Throughout The Day':
            return 'Groceries can be a single serving or multiple servings (like a tub of cookie dough or a multipack of bars).';
          default:
            return subHeader;
        }
      },
      getIcon: ({ name }: Icon) => {
        switch (name) {
          case 'Breakfast':
            return <Breakfast2 />;
          case 'Snacks':
            return <Snacks2 />;
          case 'Sweets':
            return <Sweets3 />;
          case 'Fruit':
            return <Fruits2 />;
          case 'Kids Snacks':
            return <KidsSnacks2 />;
          default:
            return <></>;
        }
      },
    };
  }

  return {
    getName: (name: string) => name,
    getSubHeader: ({ subHeader }: SubHeader) => subHeader,
    getIcon: ({ imageUrl, className }: Icon) => (
      <img alt="" className={className} src={imageUrl || ''} />
    ),
  };
}
